import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
	palette: {
		secondary: {
			main: "#F4EE84",
			//main: "#536BAD",
			light: "#EDF0F7",
			dark: "#000000",
			//dark: "#0E2647",
			contrastText: "#fff"
		},

		primary: {
			main: "#F4EE84",
			//main: "#536BAD",
			light: "#EDF0F7",
			dark: "#000000",
			//dark: "#0E2647",
			contrastText: "#fff"
		},

		black: {
			main: "#333",
			light: "#999",
			dark: "#4D4D4D",
			contrastText: "#fff"
		}
	},
	status: {
		danger: "#f00"
	},
	typography: {
		fontFamily: [
			'Helvetica'
		]
	}
});

export default theme;



// WEBPACK FOOTER //
// ./src/theme/theme.js